import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AUTHENTICATED_ENTRY,
  VENDOR_AUTHENTICATED_ENTRY,
} from "configs/AppConfig";
import { customerType } from "constants/CustomerTypeConstant";

const PublicRoute = () => {
  const { token, type } = useSelector((state) => state.auth);
  const location = useLocation();
  const partnerLandingMatch = location.pathname.startsWith("/partner-landing");
  const orderStatusMatch =
    location.pathname === "/public/order-action" ||
    location.pathname.startsWith("/public/order-action/");

  const redirectUrl =
    new URLSearchParams(location.search).get("redirect") || AUTHENTICATED_ENTRY;

  if (partnerLandingMatch || orderStatusMatch) {
    // Email action pages must remain accessible even when a user is signed in.
    return <Outlet />;
  }

  return token ? (
    <Navigate
      to={
        type === customerType.Vendor ? VENDOR_AUTHENTICATED_ENTRY : redirectUrl
      }
    />
  ) : (
    <Outlet />
  );
};

export default PublicRoute;
